import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug } from '../../../../utils';

export const LMT_ENHCMT_getBanks_API_CALL = createAsyncThunk(
  'LMT_ENHCMT_getBanks_API_CALL',
  async (payload, { getState, rejectWithValue, dispatch }) => {
    dispatch({ type: 'LMT_ENHCMT_getBanks_API_CALL/pending', payload: {} });
    const {
      getBankAPIPayload,
      successFn = () => {},
      errorFn = () => {},
      finallyFn,
    } = payload;
    const { customerId, authorization } = getBankAPIPayload;
    SecureClient({
      isEncrypted: true,
      customerId: customerId,
      route: 'getbankforweb',
      payload: {
        customerId,
      },
      otherPayloadDetailsPresent: true,
      headers: { authorization, customerid: customerId },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const bankInfoDetails = res && res.body && res.body.bankInfoDetails;
        dispatch({
          type: 'LMT_ENHCMT_getBanks_API_CALL/fulfilled',
          payload: bankInfoDetails,
        });
        if (successFn) successFn(bankInfoDetails);
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({
          type: 'LMT_ENHCMT_getBanks_API_CALL/rejected',
          payload: err,
        });
        if (errorFn) errorFn(err);
      },
      finallyFn,
    });
  }
);

export const LMT_ENHCMT_getBanks_API_CALL_extrareducer = {
  [LMT_ENHCMT_getBanks_API_CALL.pending]: (state, action) => {
    state.getBankAPICall.isLoading = true;
  },
  [LMT_ENHCMT_getBanks_API_CALL.fulfilled]: (state, action) => {
    state.getBankAPICall.isLoading = false;
    state.getBankAPICall.isSuccess = true;
    state.getBankAPICall.isError = false;
    state.getBankAPICall.response = action.payload;
  },
  [LMT_ENHCMT_getBanks_API_CALL.rejected]: (state, action) => {
    state.getBankAPICall.isLoading = false;
    state.getBankAPICall.isSuccess = false;
    state.getBankAPICall.isError = true;
    state.getBankAPICall.response = action.payload;
  },
};
